import './MediaTypeBadge.scss';

export const MediaTypeBadgeVariant = {
  // Drawer-header default: mixed renders as "Demand Gen / Demand Cap"; single uses full words.
  DEFAULT: 'default',
  // Tables and other spacious contexts: always render full words ("Demand Generation" / "Demand Capture").
  FULL: 'full',
  // Tooltips and tight cells: 2-letter "DG" / "DC" abbreviation.
  SHORT: 'short'
} as const;
export type MediaTypeBadgeVariant =
  (typeof MediaTypeBadgeVariant)[keyof typeof MediaTypeBadgeVariant];

interface MediaTypeBadgeProps {
  mediaType: string;
  variant?: MediaTypeBadgeVariant;
}

interface Labels {
  gen: string;
  cap: string;
}

const labelsFor = (variant: MediaTypeBadgeVariant, isMixed: boolean): Labels => {
  if (variant === MediaTypeBadgeVariant.SHORT) return { gen: 'DG', cap: 'DC' };
  if (variant === MediaTypeBadgeVariant.FULL) {
    return { gen: 'Demand Generation', cap: 'Demand Capture' };
  }
  if (isMixed) return { gen: 'Demand Gen', cap: 'Demand Cap' };
  return { gen: 'Demand Generation', cap: 'Demand Capture' };
};

export const MediaTypeBadge = ({
  mediaType,
  variant = MediaTypeBadgeVariant.DEFAULT
}: MediaTypeBadgeProps) => {
  if (mediaType === 'mixed') {
    const { gen, cap } = labelsFor(variant, true);
    return (
      <span className='dtc-commerce-mmm-media-badge-group'>
        <span className='dtc-commerce-mmm-media-badge gen'>{gen}</span>
        <span className='dtc-commerce-mmm-media-badge cap'>{cap}</span>
      </span>
    );
  }
  if (mediaType === 'demand_generation') {
    const { gen } = labelsFor(variant, false);
    return <span className='dtc-commerce-mmm-media-badge gen'>{gen}</span>;
  }
  if (mediaType === 'demand_capture') {
    const { cap } = labelsFor(variant, false);
    return <span className='dtc-commerce-mmm-media-badge cap'>{cap}</span>;
  }
  return null;
};
